import { Component, h, useRef } from "@lukekaalim/act";
import { html } from "@lukekaalim/act-web";
import { TheatreState } from "../../../hooks/useTheatreState";
import { DiceTemplate } from "@kosmod/andy"
import { ToolID } from "../../../defs/tools/define";
import { ID } from "@kosmod/kit";
import { ListDropTarget } from "../ListDropTarget";
import { Vector2 } from "three";

import classes from './index.module.css';

export type DiceListProps = {
  state: TheatreState
}

export const DiceList: Component<DiceListProps> = ({ state }) => {
  const id = useRef(() => ID('toolbelt')).get();

  return [
    h(html.ol, { className: classes.squareRowList }, [...state.data.diceTemplates.values()].map(die => {
      return h(html.li, {
        className: classes.squareRowListItem,
        draggable: true,
        onDragStart(event) {
          const data = event.dataTransfer;
          if (!data)
            return;

          data.setDragImage(state.selection.emptyDragImage, 0, 0);

          const toolId: ToolID = ID('theatre:tool');
          state.selection.startDrag({ type: 'tool', toolId, toolState: {
            type: 'dice:roll',
            id: toolId,
            diceTemplateId: die.id
          } });
        },
      }, die.name)
    })),
  ]
};
